import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=2c513efc&scoped=true&"
import script from "./TaskModal.vue?vue&type=script&lang=js&"
export * from "./TaskModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskModal.vue?vue&type=style&index=0&id=2c513efc&lang=scss&scoped=true&"
import style1 from "./TaskModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c513efc",
  null
  
)

export default component.exports